import Anthropic from "@anthropic-ai/sdk";

export const MODELS = {
  /** Cheap + fast — used for NL parsing. */
  haiku: "claude-haiku-4-5",
  /** Higher quality — used for summaries and conversational chat. */
  sonnet: "claude-sonnet-5",
} as const;

export type ClaudeClient = Anthropic;

/**
 * Construct an Anthropic client. Pass the user's API key (read from secure
 * storage by the caller — never hard-code).
 *
 * `dangerouslyAllowBrowser` is enabled because we run inside Tauri/Capacitor
 * WebViews where the key is loaded from the user's own machine, not exposed.
 */
export function createClient(apiKey: string): ClaudeClient {
  return new Anthropic({ apiKey, dangerouslyAllowBrowser: true });
}

/**
 * First text block of a non-streaming response, trimmed. Returns "" when the
 * response has no text block, unless `required` is set (then it throws).
 *
 * Scans for the text block rather than reading `content[0]`: on models where
 * thinking is on by default, index 0 is a `thinking` block and an index-0 read
 * silently yields "" for every call.
 */
export function extractText(res: Anthropic.Message, opts: { required?: boolean } = {}): string {
  const block = res.content.find((b) => b.type === "text");
  if (!block || block.type !== "text") {
    if (opts.required) throw new Error("Claude returned no text block");
    return "";
  }
  return block.text.trim();
}
